import React from 'react';
import { useTranslation } from 'react-i18next';
import { getProgrammePrimaryTitle } from '../../utils/programmeDisplay';
import { getJupasOrderBandColor, getJupasOrderRankLabel } from '../../utils/jupasOrderDisplay';
import JupasSplitPill from './JupasSplitPill';

/**
 * Compact informative ranking rail for collapsed Step 3.
 * Shows every ranked programme — no overflow truncation.
 */
export default function JupasRankingSidebar({
  programmes = [],
  className = '',
}) {
  const { t, i18n } = useTranslation();

  if (!programmes?.length) {
    return (
      <p className={`select-none text-[11px] leading-snug text-ink-subtle ${className}`}>
        {t('jupa.workspace.noProgrammesYet')}
      </p>
    );
  }

  return (
    <div className={`flex min-h-0 select-none flex-col gap-1.5 overflow-y-auto ${className}`}>
      {programmes.map((programme, index) => {
        const rank = getJupasOrderRankLabel(index);
        const title = getProgrammePrimaryTitle(programme, i18n.language);
        return (
          <JupasSplitPill
            key={programme.code}
            left={rank}
            right={programme.code}
            leftColor={getJupasOrderBandColor(index)}
            leftTextClass="text-neutral-900"
            variant="rank"
            title={`${rank} · ${programme.code}${title ? ` — ${title}` : ''}`}
          />
        );
      })}
    </div>
  );
}
